<template>
      <v-container
        class="fill-height"
        fluid >
        <v-row
          align="center"
          justify="center">
          <v-col
            cols="12"
            sm="8"
            md="4">
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat>
                <v-toolbar-title>Login Form</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form
                    ref="form"
                    v-model="valid">
                  <v-text-field
                    label="Username / Mobile Number"
                    name="username"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="username"
                    :rules="nameRules"
                    @keyup.enter="login"
                    :autofocus="!username"
                    required/>

                  <v-text-field
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                    :rules="nameRules"
                    @keyup.enter="login"
                    :autofocus="!!username"
                    required/>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />

                <v-btn 
                    @click="$router.push( {name: 'register'} )">
                    Register
                </v-btn>

                <v-btn 
                    color="primary"
                    :disabled="!valid"
                    @click="login">
                    Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        
      </v-container>
</template>

<script>
import Auth from '../../services/auth'

export default {
    name: 'login',
    created() {
      this.username =  this.$route.params.username || '';
    },
    methods: {
        login() {
            this.$refs.form.validate();
            if(this.valid) {
                Auth.login(this.username, this.password);
            }
        },
    },
    data() {
        return {
          username: '',
          password: '',
          valid: true,
          nameRules: [
              v => !!v || 'Field is required'
          ]
        }
    },
}
</script>